// assets/variant-media-filter.js

class VariantMediaFilter {
  constructor() {
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.mediaGallery = document.querySelector('media-gallery');

    if (!this.productForm || !this.mediaGallery) {
      console.warn('VariantMediaFilter: Could not find product form or media gallery.');
      return;
    }
    
    this.bindEvents();
    // Use a short delay to ensure the theme has selected the initial variant.
    setTimeout(() => this.filter(), 100);
  }

  bindEvents() {
    this.productForm.addEventListener('change', (event) => {
      // Filter only when a variant option changes.
      if (event.target.name && (event.target.name.includes('option') || event.target.name === 'id')) {
        this.filter();
      }
    });
  }

  filter() {
    const selectedColor = this.getSelectedColor();
    if (!selectedColor) return;

    const mediaSlides = this.mediaGallery.querySelectorAll('.slideshow-slide');
    const thumbnails = this.mediaGallery.querySelectorAll('.slideshow-controls__thumbnail');

    this.toggleMediaVisibility(mediaSlides, selectedColor);
    this.toggleMediaVisibility(thumbnails, selectedColor);
    
    // After filtering, tell the slideshow to update its state.
    const slideshowComponent = this.mediaGallery.querySelector('[ref="slideshow"]');
    if (slideshowComponent && typeof slideshowComponent.update === 'function') {
      slideshowComponent.update();
    }
  }

  getSelectedColor() {
    // Finds the selected swatch input for the 'Color' option.
    const colorSwatch = this.productForm.querySelector('fieldset[data-option-name="Color"] input:checked');
    if (colorSwatch) {
      return colorSwatch.value.toLowerCase();
    }
    return null;
  }

  toggleMediaVisibility(elements, selectedColor) {
    elements.forEach(el => {
      const elVariantColor = el.dataset.variantColor;
      // Show the element if:
      // 1. It has no variant color tag (it's a generic image).
      // 2. Its variant color tag matches the selected color.
      if (!elVariantColor || elVariantColor === selectedColor) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new VariantMediaFilter();
});
